// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paylixecommerce-pagination-container {
  display: flex;
  list-style-type: none;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
}
@media (max-width: 768px) {
  .paylixecommerce-pagination-container {
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1.25rem;
  }
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item {
  color: var(--black5);
  background-color: var(--white);
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(18, 20, 23, 0.06);
  font-weight: 500;
  background-color: var(--white);
  cursor: pointer;
  width: 2rem;
  padding: 0;
  height: 2rem;
  font-size: 0.8rem;
}
@media (max-width: 768px) {
  .paylixecommerce-pagination-container .paylixecommerce-pagination-item {
    font-size: 0.75rem;
    width: 1.85rem;
    height: 1.85rem;
  }
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item.dots:hover {
  background-color: transparent;
  cursor: default;
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item:hover {
  background: var(--black0);
  cursor: pointer;
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item.selected {
  border: 2px solid var(--purple6);
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item .arrow::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border-right: 0.12em solid rgba(0, 0, 0, 0.87);
  border-top: 0.12em solid rgba(0, 0, 0, 0.87);
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item .arrow.left {
  transform: rotate(-135deg) translate(-50%);
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item .arrow.right {
  transform: rotate(45deg);
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item.disabled {
  pointer-events: none;
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item.disabled .arrow::before {
  border-right: 0.12em solid rgba(0, 0, 0, 0.43);
  border-top: 0.12em solid rgba(0, 0, 0, 0.43);
}
.paylixecommerce-pagination-container .paylixecommerce-pagination-item.disabled:hover {
  background-color: transparent;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./client/components/pagination/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EATF;IAUI,eAAA;IACA,WAAA;IACA,mBAAA;EAEF;AACF;AAAE;EACE,oBAAA;EACA,8BAAA;EACA,+BAAA;EACA,4CAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAEJ;AAAI;EAbF;IAcI,kBAAA;IACA,cAAA;IACA,eAAA;EAGJ;AACF;AADI;EACE,6BAAA;EACA,eAAA;AAGN;AADI;EACE,yBAAA;EACA,eAAA;AAGN;AAAI;EACE,gCAAA;AAEN;AAEM;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,8CAAA;EACA,4CAAA;AAAR;AAGM;EACE,0CAAA;AADR;AAIM;EACE,wBAAA;AAFR;AAMI;EACE,oBAAA;AAJN;AAMM;EACE,8CAAA;EACA,4CAAA;AAJR;AAOM;EACE,6BAAA;EACA,eAAA;AALR","sourcesContent":[".paylixecommerce-pagination-container {\n  display: flex;\n  list-style-type: none;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  justify-content: center;\n  margin-top: 2rem;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    margin-top: 1.25rem;\n  }\n\n  .paylixecommerce-pagination-item {\n    color: var(--black5);\n    background-color: var(--white);\n    border: 1px solid var(--black2);\n    box-shadow: 0 1px 2px rgb(18 20 23 / 6%);\n    font-weight: 500;\n    background-color: var(--white);\n    cursor: pointer;\n    width: 2rem;\n    padding: 0;\n    height: 2rem;\n    font-size: 0.8rem;\n\n    @media (max-width: 768px) {\n      font-size: 0.75rem;\n      width: 1.85rem;\n      height: 1.85rem;\n    }\n\n    &.dots:hover {\n      background-color: transparent;\n      cursor: default;\n    }\n    &:hover {\n      background: var(--black0);\n      cursor: pointer;\n    }\n\n    &.selected {\n      border: 2px solid var(--purple6);\n    }\n\n    .arrow {\n      &::before {\n        position: relative;\n        content: '';\n        display: inline-block;\n        width: 0.4em;\n        height: 0.4em;\n        border-right: 0.12em solid rgba(0, 0, 0, 0.87);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.87);\n      }\n\n      &.left {\n        transform: rotate(-135deg) translate(-50%);\n      }\n\n      &.right {\n        transform: rotate(45deg);\n      }\n    }\n\n    &.disabled {\n      pointer-events: none;\n\n      .arrow::before {\n        border-right: 0.12em solid rgba(0, 0, 0, 0.43);\n        border-top: 0.12em solid rgba(0, 0, 0, 0.43);\n      }\n\n      &:hover {\n        background-color: transparent;\n        cursor: default;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
